import { cn } from "@wags/ui/ui-utils";
import type { ComponentProps } from "react";

export const OPTION_ROW_CLASS =
    "flex min-h-11 w-full items-center gap-2.5 rounded-nested px-2 py-2 text-left transition-colors [@media(hover:hover)]:hover:bg-doberman-black/4 active:bg-doberman-black/7 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-inset focus-visible:ring-labrador-yellow";

export const OPTION_INDICATOR_CLASS =
    "flex size-4.5 shrink-0 items-center justify-center transition-colors";

const OPTION_GROUP_CLASS = "-mx-2 flex min-w-0 flex-col gap-0.5";

type OptionGroupProps =
    | ({ control: "checkbox"; label: string } & ComponentProps<"fieldset">)
    | ({ control?: "radio"; label?: string } & ComponentProps<"div">);

export function OptionGroup(props: OptionGroupProps) {
    if (props.control === "checkbox") {
        const { control: _control, label, className, ...fieldsetProps } = props;
        return (
            <fieldset
                aria-label={label}
                {...fieldsetProps}
                data-slot="option-group"
                className={cn(OPTION_GROUP_CLASS, "border-0 p-0", className)}
            />
        );
    }
    const { control, label, className, ...divProps } = props;
    return (
        <div
            role={control === "radio" ? "radiogroup" : undefined}
            aria-label={label}
            {...divProps}
            data-slot="option-group"
            className={cn(OPTION_GROUP_CLASS, className)}
        />
    );
}
